/*
 * Lista de pagos utilizando saldo a favor.
 *
 * Muestra el resumen de pagos realizados haciendo uso del saldo a favor.
 *
 * Created on Thu Aug 03 2023 by José Luis Chávez Ayala.
 *
 * Copyright (c) 2023 Turn My App.
 */

<template>
  <div>
    <b-modal
      id="used-credit-balance-modal"
      ref="used-credit-balance-modal"
      title="Saldo a favor utilizado"
      size="lg"
      :hide-footer="true"
    >
      <b-card-text>
        <b-row>
          <b-col>
            <h4>{{ payerName }}</h4>
          </b-col>

          <b-col
            md="12"
            class="d-flex"
          >
            <h6>{{ usedCreditBalance | currency }} total utilizado</h6>
            <small class="text-muted ml-25">({{ remainigCreditBalance | currency }} monto restante)</small>
          </b-col>

          <b-col>
            <OrderUsedCreditBalancePaymentsList
              :model-id="modelId"
              :model-type="modelType"
            />
          </b-col>

        </b-row>
      </b-card-text>

    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BCardText, BRow, BCol,
} from 'bootstrap-vue'

import OrderUsedCreditBalancePaymentsList from '@/modules/trade/orders/components/lists/OrderUsedCreditBalancePaymentsList.vue'

export default {
  components: {
    BModal,
    BCardText,
    BRow,
    BCol,
    OrderUsedCreditBalancePaymentsList,
  },
  props: {
    /**
     * Identificador del modelo, puede ser el id de la orden o de la devolución
     */
    modelId: {
      type: Number,
      required: true,
    },
    /**
     * Tipo de modelo, puede ser order o devolución
     */
    modelType: {
      type: String,
      required: true,
    },
    /**
     * Nombre del pagador
     */
    payerName: {
      type: String,
      required: true,
    },
    /**
     * Saldo a favor utilizado
     */
    usedCreditBalance: {
      type: Number,
      required: true,
    },
    /**
     * Saldo a favor restante
     */
    remainigCreditBalance: {
      type: Number,
      required: true,
    },
  },
  methods: {
    showModal() {
      this.$refs['used-credit-balance-modal'].show()
    },
    hideModal() {
      this.$refs['used-credit-balance-modal'].hide()
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
